export const ROWS_PER_PAGE = 10;

export const EXCHANGE_RATE = 7.5345;